import React from 'react';

import { CustomCellRendererProps } from 'ag-grid-react';

import type { ShipmentEmbryo } from '@/services/shipping/types';

export const CaneCellRenderer = (
  params: CustomCellRendererProps<ShipmentEmbryo, unknown>,
): React.ReactElement => {
  try {
    const embryoId = params.data?.id;
    const recaneEmbryoIds = (params as any).recaneEmbryoIds || [];
    const caneCode = String(params.value ?? '');
    const fertilizationId = (params.data as any)?.fertilizationId;

    const isRecane = embryoId && recaneEmbryoIds.includes(embryoId);

    const renderCaneCode = () => {
      return <span>{caneCode}</span>;
    };

    return (
      <span className="inline-flex items-center">
        {isRecane && (
          <span
            className="mr-2 inline-flex h-5 w-5 items-center justify-center rounded-full bg-purple-500 text-xs leading-none font-semibold text-white"
            title="Recane"
          >
            R
          </span>
        )}
        {renderCaneCode()}
      </span>
    );
  } catch (error) {
    console.error('Error in CaneCellRenderer:', error);
    return <span>{String(params.value ?? '')}</span>;
  }
};
